




















































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
// @ts-ignore
import { DownloadIcon } from "vue-feather-icons";
import ExportSetting from "@/models/exportSetting";
import Delimiter from "@/models/delimiter";
import Request from "@/models/checkRequest/request";
import Response from "@/models/checkRequest/response";
import { unparse } from "papaparse";

@Component({
  components: {
    DownloadIcon,
  },
  computed: {
    ...mapState("projects", ["queueBusy"]),
    ...mapGetters("projects", ["requests"]),
    ...mapGetters("projects", ["requestsUnchecked"]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
})
export default class Export extends Vue {
  // mapState + mapGetters
  queueBusy!: boolean;
  requests!: Array<Request>;
  requestsUnchecked!: Array<Request>;
  hasActiveSubscription!: boolean;

  exportLayout = "expanded";

  columnList: Array<string> = [];
  availableDelimiters: Array<Delimiter> = [
    new Delimiter({ label: "comma", value: "," }),
    new Delimiter({ label: "colon", value: ";" }),
    new Delimiter({ label: "pipe", value: "|" }),
  ];

  delimiter = ",";
  previewLength = 3;
  requestsPreview: Array<Request> = [];

  containsColumn(key: string): boolean {
    const column = this.selectedColumns.find((c) => c.key === key);
    return column ? true : false;
  }

  isLastColumn(key: string): boolean {
    const lastColumn = this.selectedColumns[this.selectedColumns.length - 1];

    if (lastColumn) {
      return lastColumn.key === key;
    }

    return false;
  }

  mounted() {
    this.requestsPreview = [];
    for (let x = 0; x < this.previewLength && x < this.requests.length; x++) {
      this.requestsPreview.push(this.requests[x]);
    }
  }

  get selectedColumns(): Array<ExportSetting> {
    return this.exportColumns.filter((c) => c.value === true);
  }

  exportColumns: Array<ExportSetting> = [
    new ExportSetting({
      key: "id",
      value: true,
      description: "Id",
      readonly: true,
    }),
    new ExportSetting({
      key: "httpMethod",
      value: true,
      description: "HTTP method",
      readonly: false,
    }),
    new ExportSetting({
      key: "requestedUrl",
      value: true,
      description: "Url",
      readonly: false,
    }),
    new ExportSetting({
      key: "statusCode",
      value: true,
      description: "Status code",
      readonly: false,
    }),
    new ExportSetting({
      key: "targetUrl",
      value: true,
      description: "Destination url",
      readonly: false,
    }),
    new ExportSetting({
      key: "responseTime",
      value: true,
      description: "Response time (ms)",
      readonly: false,
    }),
  ];

  exportAll() {
    if (this.exportLayout == "expanded") {
      this.export(this.requests);
    } else {
      this.exportCompact(this.requests);
    }
  }

  exportCompact(requests: Array<Request>) {
    if (!this.hasActiveSubscription || !requests.length) {
      return;
    }

    const csv: any = {
      fields: [
        "Id",
        "Http Method",
        "Url",
        "Status Code",
        "Target",
        "Status Code 1",
        "Target 1",
        "Status Code 2",
        "Target 2",
        "Status Code 3",
        "Target 3",
        "Status Code 4",
        "Target 4",
      ],
      data: [],
    };

    requests.forEach((request) => {
      if (request.hasResults) {
        // spread operator is used
        // to conditionally push an entry
        // see: https://2ality.com/2017/04/conditional-literal-entries.html
        csv.data.push([
          request.id,
          request.results[0].httpMethod,
          request.results[0].requestedUrl,
          ...this.processResponses(request.results),
        ]);
      } else {
        csv.data.push([request.id, request.httpMethod, ""]);
      }
    });

    //
    // Unparse
    const parsedCsv = unparse(csv, { delimiter: this.delimiter });
    //
    // Trigger a download
    const blob = new Blob([parsedCsv], { type: "text/plain" });
    const e = document.createEvent("MouseEvents");
    const a = document.createElement("a");
    a.download = "export-compact.csv";
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["text/csv", a.download, a.href].join(":");
    e.initEvent("click", true, false);
    a.dispatchEvent(e);
  }

  processResponses(responses: Array<Response>): Array<string> {
    const returnObject: Array<string> = [];

    for (let x = 0; x < responses.length; x++) {
      if (responses[x].statusCode) {
        returnObject.push(responses[x].statusCode.toString());
      }

      if (responses[x].targetUrl) {
        returnObject.push(responses[x].targetUrl as string);
      }
    }

    return returnObject;
  }

  export(requests: Array<Request>) {
    if (!this.hasActiveSubscription || !requests.length) {
      return;
    }

    const csv: any = {
      fields: this.selectedColumns.map((c) => c.description),
      data: [],
    };

    requests.forEach((request) => {
      //
      // No results
      if (!request.results.length) {
        csv.data.push([
          request.id,
          ...(this.containsColumn("requestedUrl") ? [request.url] : []),
          ...(this.containsColumn("httpMethod") ? [request.httpMethod] : []),
          ...(this.containsColumn("statusCode") ? [] : []),
          ...(this.containsColumn("targetUrl") ? [] : []),
          ...(this.containsColumn("responseTime") ? [] : []),
        ]);
      }
      //
      // Has results
      for (let x = 0; x < request.results.length; x++) {
        // spread operator is used
        // to conditionally push an entry
        // see: https://2ality.com/2017/04/conditional-literal-entries.html
        csv.data.push([
          x == 0 ? request.id : "",
          ...(this.containsColumn("requestedUrl")
            ? [request.results[x].requestedUrl]
            : []),
          ...(this.containsColumn("httpMethod")
            ? [request.results[x].httpMethod]
            : []),
          ...(this.containsColumn("statusCode")
            ? [request.results[x].statusCode]
            : []),
          ...(this.containsColumn("targetUrl")
            ? [request.results[x].targetUrl]
            : []),
          ...(this.containsColumn("responseTime")
            ? [request.results[x].responseTime]
            : []),
        ]);
      }
    });

    //
    // Unparse
    const parsedCsv = unparse(csv, { delimiter: this.delimiter });
    //
    // Trigger a download
    const blob = new Blob([parsedCsv], { type: "text/plain" });
    const e = document.createEvent("MouseEvents");
    const a = document.createElement("a");
    a.download = "export.csv";
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["text/csv", a.download, a.href].join(":");
    e.initEvent("click", true, false);
    a.dispatchEvent(e);
  }
}
